<script setup>
import { sendConfiguratorEvent } from './common/event-tracking.js';
import Canvas from './components/Canvas/Canvas.vue';
import Navigation from './components/Navigation/Navigation.vue';
import Overlays from './components/Overlays/Overlays.vue';
import ScrollArea from './components/ScrollArea/ScrollArea.vue';
import Steps from './components/Steps/Steps.vue';
import { useConfiguratorStore } from "./stores/configurator";
import { useUiStore } from './stores/ui.js';

const configurationStore = useConfiguratorStore();
const uiStore = useUiStore();

// Init stores
const json = JSON.parse(document.querySelector("#vue-data").innerText);
configurationStore.loadInitialData(json);
uiStore.loadInitialData(json);

configurationStore.init();

// Track every 5 seconds
const uniqueHash = Math.random().toString(36).substring(7);
setInterval(() => {
    sendConfiguratorEvent('bounce', uiStore.currentStep, uniqueHash)
}, 5000)
</script>

<template>
    <div class="Configurator tw-flex tw-flex-col height-screen tw-w-full lg:tw-overflow-hidden lg:tw-flex-row lg:tw-grow">
        <Canvas class="tw-bg-gray-100 tw-relative tw-aspect-[375/320] tw-shrink-0 tw-w-full tw-max-h-[620px] lg:tw-max-h-[none] lg:tw-w-8/12 lg:tw-aspect-auto lg:tw-shrink" />
        <Overlays />

        <div 
            class="tw-relative tw-flex tw-shrink-0 tw-flex-col tw-grow tw-justify-between lg:tw-w-4/12 lg:tw-min-w-[375px] tw-overflow-x-hidden lg:tw-border-l lg:tw-border-gray-100 tw-z-50 tw-bg-white tw-transition-all tw-duration-300"
            :class="{'tw-mt-[-50vw] lg:tw-mt-0': !uiStore.isScrollingUp || uiStore.showDetails || uiStore.showRoomConfig}"
        >
            <div class="tw-flex tw-flex-col tw-grow">
                <Steps />

                <ScrollArea />

                <Navigation />
            </div>
        </div>
    </div>
</template>
